<template>
  <div class="not-find">
    <div class="desc">
      <p>404~</p>
      <p>您要找的页面不见了~</p>
    </div>
    <el-button class="btn" type="text" @click="$router.push({name:'work.index.homeIndex'})">返回首页 </el-button>
  </div>
</template>

<script>
import router from '@/router'

export default {
  name: "notFind",
  data() {
    return {
      pathName:'',
      name:''
    }
  },
  created() {
    console.log(
        this.$store.state.menus
    )
    const menus = this.$store.state.menus[0].children
    for (let item of menus) {
      if (item.meta.isShow) {
        this.name = item.meta.title
        this.pathName = item.name
        break
      }
    }
  }
}
</script>

<style scoped lang="less">
.not-find {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .desc {
    font-size: 30px;
    color: red;
  }

  .btn {
    font-size: 20px;
    margin-left: 40px;
  }

}
</style>